<input type="number"
       [formControl]="valueFormControl"
       [placeholder]="placeholderValue"
       [min]="minValue"
       [max]="maxValue"
       pInputText
/>

